// Pfad: src/components/SalaryInfo.jsx

import React from "react";
import "../styles/salaryInfo.css"; // NEU: eigenes CSS importieren

const SalaryInfo = ({ salary }) => {
    if (!salary || salary.length === 0) return null;

    // Total-Credits berechnen
    const totalCredits = salary.reduce((sum, s) => sum + (s.amount || 0), 0);

    // Admission automatisch setzen: ab 2 Schichten = FESTIVALPASS
    const admission = salary.length >= 2 ? "FESTIVALPASS" : salary[0]?.admission || "Tageseintritt";

    return (
        <div className="salary-info">
            <h3 className="salary-title">Unser Dankeschön ❤️</h3>
            <ul className="salary-list">
                {salary.map((entry, idx) => (
                    <li key={idx}>
                        <strong>{entry.department}</strong>: {entry.amount} Bätzeli ({entry.admission})
                    </li>
                ))}
            </ul>

            <div className="salary-summary">
                <span className="salary-total">Total: {totalCredits} Bätzeli</span>
                <span className="salary-badge">Eintritt:  {admission}</span>
            </div>
        </div>
    );
};

export default SalaryInfo;
